'use client'
import { Divider, Grid, Typography } from '@mui/material'
import { colors } from '../../src/Theme/LegacyTheme'
import BodyFullWidthContainer from '@/UI/BodyFullWidthContainer/BodyFullWidthContainer'
import DynamicForm, { FieldConfig } from '@/components/DynamicForm/DynamicForm'
import {
  validateEmail,
  validateEnquiry,
  validateName,
  validateTelephoneNumber
} from '@/utils/ContactUs/validations'
import OpeningHours from '@/components/OpeningHours/OpeningHours'

const callRequestFields100: FieldConfig[] = [
  {
    name: 'name',
    label: 'Name',
    validate: validateName
  },
  {
    name: 'telephoneNumber',
    label: 'Telephone',
    type: 'tel',
    validate: validateTelephoneNumber
  },
  {
    name: 'alreadyApplied',
    label: 'I have already applied',
    fieldType: 'checkbox'
  }
]

const fieldsLeft: FieldConfig[] = [
  {
    name: 'name',
    label: 'Name',
    validate: validateName
  },
  {
    name: 'telephoneNumber',
    label: 'Telephone',
    type: 'tel',
    validate: validateTelephoneNumber
  },
  {
    name: 'email',
    label: 'Email',
    type: 'email',
    validate: validateEmail
  }
]

const fieldsRight: FieldConfig[] = [
  {
    name: 'enquiry',
    label: 'Enquiry',
    multiline: true,
    rows: 8,
    validate: validateEnquiry
  }
]

const PageContent = () => {
  return (
    <>
      <BodyFullWidthContainer bgColor={colors.white}>
        <Grid
          component="section"
          container
          direction="row"
          mb={6}
          sx={{
            justifyContent: { xs: 'center', mdplus: 'right' }
          }}
        >
          <Grid item xs={12} md={6} mdplus={7} lg={8} mb={3}>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '32px', sm: '50px' },
                mb: { xs: 4 },
                marginTop: { xs: 5, lg: 0 }
              }}
            >
              Get in touch
            </Typography>
            <Typography
              variant="h1"
              color={colors.blue}
              sx={{
                fontSize: { xs: '28px', sm: '40px' },
                mb: 8
              }}
            >
              01625 619 944
            </Typography>
            <Typography variant="body1" component="p" color={colors.blue} sx={{ fontWeight: 400 }}>
              Our lines are currently open
            </Typography>
            <OpeningHours />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            mdplus={5}
            lg={4}
            mb={3}
            sx={{
              backgroundColor: colors.blue,
              color: colors.white,
              paddingX: { xs: 4, md: 5 },
              paddingY: { xs: 5, md: 6 }
            }}
          >
            <DynamicForm
              fields100Col={callRequestFields100}
              emailType="CallRequest"
              submitTxt="Call me back"
              darkTheme
            />
          </Grid>
        </Grid>
        <Divider orientation="horizontal" />
        <Grid component="section" container mb={8} mt={6}>
          <Grid item xs={12} sx={{ marginTop: { xs: 2, mdplus: 3 } }}>
            <DynamicForm
              fieldsLeftCol={fieldsLeft}
              fieldsRightCol={fieldsRight}
              emailType="ContactRequest"
            />
          </Grid>
        </Grid>
      </BodyFullWidthContainer>
    </>
  )
}

export default PageContent
